import { GameTypeValue } from '@/shared/config/constants';
import { fetchAPI } from '@/shared/lib/api/client';

import { LeaderboardPeriod, LeaderboardResponse, LeaderboardSortBy, MyRankResponse } from '../model/types';

const PAGE_SIZE = 50;

export const leaderboardApi = {
  async getLeaderboard(
    period: LeaderboardPeriod,
    sortBy: LeaderboardSortBy = 'profit',
    gameType: GameTypeValue = 'global',
    offset = 0,
    limit = PAGE_SIZE,
  ): Promise<LeaderboardResponse> {
    const { data } = await fetchAPI.get<LeaderboardResponse>(`/leaderboard/${period}`, {
      params: { sort_by: sortBy, game_type: gameType, offset, limit },
    });
    return data;
  },

  async getMyRank(
    period: LeaderboardPeriod,
    sortBy: LeaderboardSortBy = 'profit',
    gameType: GameTypeValue = 'global',
  ): Promise<MyRankResponse> {
    const { data } = await fetchAPI.get<MyRankResponse>(`/leaderboard/${period}/my-rank`, {
      params: { sort_by: sortBy, game_type: gameType },
    });
    return data;
  },
};
